import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

export const entityRoute = {
    GET_COMPANIES_TREE: "dashboard/core/company/list/tree",
};
export default {
    listCompanies() {
        let newInfo = [];
        return new Promise(resolve => {
            http
                .get(entityRoute.GET_COMPANIES_TREE)
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron compañías");
                        return;
                    }
                    if (code < 0) {
                        toast.error("Error al consultar las companías");
                        return;
                    }
                    const companiesList = data.info;
                    this.processTree(companiesList);
                    newInfo = companiesList;
                })
                .catch(ex => {
                    console.log(ex);
                    toast.error("Error al consultar las companías");
                })
                .finally(() => resolve(newInfo));
        });
    },
    processTree(companies) {
        for (let index = 0; index < companies.length; index++) {
            let company = companies[index];
            company.label = company.title ? company.title : company.name;
            company.id = company.code;
            if (company.children) {
                this.processTree(company.children);
            }
        }
    }
};